import {helpPopoverRef} from '../../../_shared/Help/constants';
import texts from '../../../_shared/Help/texts';
import {Column} from '../../../stores/Form';
import {getFieldHelp, getFormHelpText} from '../actions/help';

export type params = {
    anchor: HTMLElement;
    Fname: string;
    column?: Column;
    onLinkClick?: (arg: {eName: string}) => void;
};

export const showHelp = async (props: params) => {
    const {anchor, Fname, column, onLinkClick} = props;
    const helpPopover = helpPopoverRef.current;

    if (helpPopover && anchor) {
        const helpData = column ? await getFieldHelp(Fname, column) : await getFormHelpText(Fname);
        // Todo: @i_lavs / @alex_r add correct handlers of the help links
        helpPopover.showHelpPopover({
            title: column ? column.Title + ':' : texts.help,
            content: helpData?.content,
            linkList: helpData?.linkData,
            onLinkClick,
            anchor
        });
    }
};
